define(function (require) {
    "use strict";

    var LE = require("app");
    var CONST = require("const");


    var Page = require("ui.components/page/Page");

    var UserListController = require("user-management-controllers/users/UserListController");
    var UserWithProfilesListController = require("user-management-controllers/users/UserWithProfilesListController");
    var SkillListController = require("user-management-controllers/skills/SkillListController");
    var AgentGroupListController = require("user-management-controllers/agent-groups/AgentGroupListController");
    var LobListController = require("user-management-controllers/lobs/LobListController");
    var ProfileListController = require("user-management-controllers/profiles/ProfileListController");

    var UsersFooterView = require("user-management-views/users/UsersFooterView");
    var SkillsFooterView = require("user-management-views/skills/SkillsFooterView");
    var AgentGroupsFooterView = require("user-management-views/agent-groups/AgentGroupsFooterView");
    var LobsFooterView = require("user-management-views/lobs/LobsFooterView");
    var ProfilesFooterView = require("user-management-views/profiles/ProfilesFooterView");

    var TABS = {
        USERS: "users",
        SKILLS: "skills",
        PROFILES: "profiles",
        AGENT_GROUPS: "agentGroups",
        LOBS: "lobs"
    };

    var TABS_MAP = {};
    TABS_MAP[TABS.USERS] = {
        dictionaryKey: "users",
        path: "users",
        FooterView: UsersFooterView,
        ViewController: LE.sessionManager.hasProfilesFeature() ? UserWithProfilesListController : UserListController,
        isEnabled: function() {
            return !LE.sessionManager.hasProfilesFeature() || LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.VIEW_LE_USER_LIST);
        }
    };
    TABS_MAP[TABS.SKILLS] = {
        dictionaryKey: "skills",
        path: "skills",
        FooterView: SkillsFooterView,
        ViewController: SkillListController,
        kpEvent: "working-with-skills",
        isEnabled: function() {
            return !LE.sessionManager.hasProfilesFeature() || LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.VIEW_LE_SKILL_LIST);
        }
    };

    TABS_MAP[TABS.PROFILES] = {
        dictionaryKey: "profiles",
        path: "profiles",
        FooterView: ProfilesFooterView,
        ViewController: ProfileListController,
        kpEvent: "working-with-profiles",
        isEnabled: function() {
            return LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.VIEW_LE_PROFILE_LIST) && LE.sessionManager.hasProfilesFeature();
        },
        dataAttributes: {profilespersonalization:"PROFILES"}
    };

    TABS_MAP[TABS.AGENT_GROUPS] = {
        dictionaryKey: "agentGroups",
        path: "agentGroups",
        FooterView: AgentGroupsFooterView,
        ViewController: AgentGroupListController,
        kpEvent: "working-with-agent-groups",
        isEnabled: function() {
            return (CONST.SOURCE_ENUM.LEGACY !== LE.sessionManager.getAccountSettingValueByID(LE.sessionManager.ACCOUNT_SETTINGS_ID.USERS_SOURCE) && LE.sessionManager.hasAgentGroupsFeature() && (LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.VIEW_LE_AGENT_GROUP_LIST) || !LE.sessionManager.hasProfilesFeature()));
        }
    };

    TABS_MAP[TABS.LOBS] = {
        dictionaryKey: "lobs",
        path: "lobs",
        FooterView: LobsFooterView,
        ViewController: LobListController,
        kpEvent: "manage-lines-of-business",
        isEnabled: function() {
            return (LE.siteSettings.lobSettings.hasLobSettingEnabled() && (LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.VIEW_LE_LOB_LIST) || !LE.sessionManager.hasProfilesFeature()));
        }
    };

    var ModuleTabsController = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {
        ModuleTabsController = Marionette.Controller.extend({
            pageView: null,
            insideView: null,
            footerView: null,
            selectedTabId: null,

            initialize: function(options) {
                this._initialize(options);
            },

            getView: function() {
                return this._getView();
            },

            showSkillList: function() {
                this._showSkillList();
            },

            showUserList: function() {
                this._showUserList();
            },

            showProfileList: function() {
                this._showProfileList();
            },

            showAgentGroupsList: function() {
                this._showAgentGroupsList();
            },

            showLobList: function() {
                this._showLobList();
            },

            onNavigateOut: function(){
                this._onNavigateOut();
            },

            getFirstTabPath: function() {
                return _getFirstTabPath();
            },

            _initialize: function(options) {
                LEUserManagement.logger.info("initializing", "ModuleTabsController:initialize");
                _.each(TABS,function(tabConfig){
                    var config = TABS_MAP[tabConfig];
                    config.viewController = new config.ViewController();
                    config.footerView = new config.FooterView({"isListView": true});
                },this);
            },

            _getView: function() {
                this._initPageView();
                return this.pageView;
            },

            _initPageView: function () {
                if (!this.pageView) {
                    this.pageView = new Page({
                        moduleName: LEUserManagement.moduleName,
                        context: LE.context,
                        permutation: Page.PERMUTATION.Standard,
                        isPermanent: true,
                        header: {
                            title: {
                                tabs: _getHeaderTabsArr()
                            }
                        },
                        insideViewRegionFunction: Page.REGION_SHOW_FUNCTION_NAMES.ADD,
                        footerViewRegionFunction: Page.REGION_SHOW_FUNCTION_NAMES.ADD
                    });
                    this._bindEventsPage();
                }
            },

            _bindEventsPage: function() {
                this.listenTo(this.pageView, "close", this._onPageClose);
            },

            _onPageClose: function() {
                if (this.pageView) {
                    this.stopListening(this.pageView);
                }
                this.pageView = null;
            },

            _showSkillList: function() {
                this.selectedTabId = TABS.SKILLS;
                this._showView();
            },

            _showUserList: function() {
                this.selectedTabId = TABS.USERS;
                this._showView();
            },

            _showProfileList: function() {
                this.selectedTabId = TABS.PROFILES;
                this._showView();
            },

            _showAgentGroupsList: function() {
                this.selectedTabId = TABS.AGENT_GROUPS;
                this._showView();
            },

            _showLobList: function() {
                this.selectedTabId = TABS.LOBS;
                this._showView();
            },

            _showView: function(viewOptions) {
                this._unbindEventsActiveView();

                this.activeController = TABS_MAP[this.selectedTabId].viewController;
                this.footerView = TABS_MAP[this.selectedTabId].footerView;
                this.insideView = this.activeController.getView(viewOptions);

                this.pageView.setTitle({selectedTabId: this.selectedTabId});
                this.pageView.setDescription(LE.translator.translate("LEUserManagement.headerTabs."+TABS_MAP[this.selectedTabId].dictionaryKey+".description"));
                this.pageView.setInsideView(this.insideView);
                this.pageView.setFooterView(this.footerView);
                this.pageView.setKnowledgePack(_getKPContentObj(this.selectedTabId));

                this._bindEventsActiveView();
            },

            _bindEventsActiveView: function() {
                this.listenTo(this.insideView, "page:headerTabsChange", this._onHeaderTabsChange);
            },

            _onHeaderTabsChange: function(selectedTabId) {
                this._unbindEventsActiveView();
                var path = TABS_MAP[selectedTabId].path;
                LEUserManagement.router.navigate(path);
            },
            _onNavigateOut: function(){
                this.activeController.onNavigateOut();
            },

            _unbindEventsActiveView: function() {
                if (this.insideView) {
                    this.stopListening(this.insideView);
                }
            }
        });

        function _getHeaderTabsArr() {
            var tabsArr = [];
            _.each(TABS, function(tab) {
                if(TABS_MAP[tab].isEnabled()) {
                    var tabItem = {
                        id: tab,
                        name: LE.translator.translate("LEUserManagement.headerTabs." + TABS_MAP[tab].dictionaryKey + ".name"),
                        tooltip: LE.translator.translate("LEUserManagement.headerTabs." + TABS_MAP[tab].dictionaryKey + ".name")
                    };
                    if (TABS_MAP[tab].dataAttributes){
                        tabItem.dataAttributes = TABS_MAP[tab].dataAttributes;
                    }
                    tabsArr.push(tabItem);
                }
            });
            _addDataAttributeToLastTab(tabsArr);
            return tabsArr;
        }

        function _addDataAttributeToLastTab(tabsArray) {
            var lastArrayTab = tabsArray[tabsArray.length - 1];
            if (lastArrayTab && (_.isUndefined(lastArrayTab.dataAttributes) || _.isUndefined(lastArrayTab.dataAttributes.personalization))) {
                lastArrayTab.dataAttributes = lastArrayTab.dataAttributes || {};
                lastArrayTab.dataAttributes.personalization = "LOB";
            }
        }

        function _getFirstTabPath() {
            var path = TABS_MAP[TABS.USERS].path; //use a default for those who has no permissions at all
            if (_getHeaderTabsArr()[0]) {
                path = TABS_MAP[_getHeaderTabsArr()[0].id].path;
            }
            return path;
        }

        function _getKPContentObj(selectedTabId) {
            var kpContent = {};
            if (TABS_MAP[selectedTabId].kpEvent) {
                kpContent.eventId = TABS_MAP[selectedTabId].kpEvent;
                kpContent.text = LE.translator.translate("LEUserManagement.headerTabs." + TABS_MAP[selectedTabId].dictionaryKey + ".kpText");
            }

            return kpContent;
        }
    }

    LE.module("LEUserManagement", moduleDefinition);

    return  ModuleTabsController;
});
